export const C = {
  navy: "#0A1628", dark: "#0D1F35",
  card: "#161b30", 
  deep: "#0f1629", 
  border: "#272749",
  cardBorder: "#334155",
  surface: "#0C1E38",
  orange: "#F15A22", teal: "#00C9A7", green: "#39B54A", cyan: "#00D4FF",
  white: "#FFFFFF", 
  muted: "#b3b3b3", 
  inp: "#0f172a80", 
  sub: "#94A3B8FF",
  dim: "#475569", red: "#FF5050", amber: "#FFBC42", purple: "#7B5FFF", pink: "#EC4899",
};

export const NAV = [
  { id: "dashboard", label: "Dashboard", icon: "⚡" },
  { id: "security", label: "Security Center", icon: "🛡" },
  { id: "routes", label: "AI Routes", icon: "🔀" },
  { id: "resilience", label: "Resilience", icon: "🔌" },
  { id: "rag", label: "RAG", icon: "📚" },
  { id: "agents", label: "Agent Connect", icon: "🤖" },
  { id: "enrichment", label: "Enrichment", icon: "✨" },
  { id: "models", label: "Models", icon: "🧠" },
  { id: "monetize", label: "Monetize", icon: "💰" },
  { id: "developers", label: "Developers", icon: "👥" },
  { id: "settings", label: "Settings", icon: "⚙️" },
];

export const sevC = {
  critical: C.red,
  high: C.orange,
  medium: C.amber,
  low: C.teal
};

export const cbC = {
  closed: C.green,
  open: C.red,
  "half-open": C.amber
};

export const CONFIG_OPTIONS = [
  {v: 'git', l: 'Git Configuration'},
  {v: 'gcs', l: 'Google Cloud Storage'},
  {v: 'standard', l: 'API Standard Linting'},
  {v: 'custom', l: 'Api Custom Linting'}
];


